import React from "react"

import animationData from "./loading.json"
import {Lottie} from "@crello/react-lottie"
import Styles from "./loading.less"

export const Loading = () => (
    <Lottie
        width="54px"
        className={Styles["ss-lottie-container"]}
        config={{animationData: animationData, loop: true, autoplay: true}}
    />
)
